import React, { ReactElement } from 'react';
import images from 'assets/images';
import { FormattedMessage } from 'react-intl';

export type SetPasswordRequirementsProps = {
	password: string;
	confirmPassword: string;
};

type SetPasswordRequirementProps = {
	password: string;
	confirmPassword: string;
	text: string | ReactElement;
	validator: (password: string, confirmPassword: string) => boolean;
};

const requirements: Omit<SetPasswordRequirementProps, 'password' | 'confirmPassword'>[] = [
	{
		text: <FormattedMessage id="auth.reset-password.action.set-password.validate.number" />,
		validator: password => !!password.match(/[0-9]/),
	},
	{
		text: <FormattedMessage id="auth.reset-password.action.set-password.validate.special" />,
		validator: password => !!password.match(/[~!@#$%^&*()_+.]/),
	},
	{
		text: <FormattedMessage id="auth.reset-password.action.set-password.validate.uppercase" />,
		validator: password => !!password.match(/[A-Z]/),
	},
	{
		text: <FormattedMessage id="auth.reset-password.action.set-password.validate.length" />,
		validator: password => password.length >= 12,
	},
	{
		text: <FormattedMessage id="auth.reset-password.action.set-password.validate.confirmPassword" />,
		validator: (password, confirmPassword) => !!password && password === confirmPassword,
	},
];

const SetPasswordRequirement = ({ password, confirmPassword, validator, text }: SetPasswordRequirementProps) => {
	const isValid = validator(password, confirmPassword);

	return (
		<div className="d-flex flex-row passwordRequirements--requirement">
			<div className="passwordRequirements--requirement--icon">
				<img src={isValid ? images.icon.password.valid : images.icon.password.invalid} alt="icon" />
			</div>
			<div
				style={{
					color: isValid ? 'var(--color--content--foreground-35)' : 'var(--color--content--foreground-80)',
				}}
			>
				{text}
			</div>
		</div>
	);
};

export const SetPasswordRequirements = ({ password, confirmPassword }: SetPasswordRequirementsProps) => {
	return (
		<div className="d-flex flex-column passwordRequirements fs-4">
			<div className="text-center">
				<FormattedMessage id={`auth.reset-password.action.set-password.validate.title`} />
			</div>
			<div className="d-flex flex-column passwordRequirements--list">
				{requirements.map(requirement => (
					<SetPasswordRequirement password={password} confirmPassword={confirmPassword} {...requirement} />
				))}
			</div>
			<div className="passwordRequirements--info font-italic font-weight-light text-center">
				<FormattedMessage id={`auth.reset-password.action.set-password.validate.info`} />
			</div>
		</div>
	);
};
